import React from 'react';

export const NetworkContext = React.createContext(null);
export const SelectedTokenContext = React.createContext(null);
export const SuperTokensContext = React.createContext([]);
export const ProviderContext = React.createContext(null);
export const SignerContext = React.createContext(null);
